<script setup lang="ts">
import { computed, watch } from "vue"
import FormRow from "@/components/Common/FormRow.vue"

const emits = defineEmits(['update:modelValue'])

type officeableType = {
  id: number | null
  name: string | null
  type: string | null
}
const props = withDefaults(
  defineProps<{
    title: string
    required: boolean
    disabled: boolean
    items: any[]
    itemTitle: string
    itemValue: string
    modelValue: officeableType | { name: string | null, value: number | null } | undefined
    errors: string[]
  }>(),
  {
    disabled: false
  }
)

const selectedItem = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits("update:modelValue", value);
  },
})

const effectiveItems = computed(() => {
  return props.items.filter((item) => item.name !== null);
})

const hasSingleEffectiveItem = computed(() => {
  return effectiveItems.value.length === 1;
})

watch(effectiveItems, (newItems) => {
  if (newItems.length === 1) {
    selectedItem.value = newItems[0]
  }
})
</script>

<template>
  <FormRow
    :title="props.title"
    :errors="props.errors"
    :required="props.required"
  >
    <div
      v-if="hasSingleEffectiveItem"
      class="pt-2"
    >
      {{ selectedItem?.name }}
    </div>
    <v-select
      v-else
      hide-details="auto"
      class="small pt-2"
      v-model="selectedItem"
      :items="props.items"
      :item-title="props.itemTitle"
      :item-value="props.itemValue"
      v-bind="{'return-object': true}"
      density="compact"
      :disabled="props.disabled"
      :error-messages="props.errors"
      :clearable="false"
    />
  </FormRow>
</template>